import * as ApplicationApi from './legacyApplicationApiService';
import CddService from './cddservice';
import o2ApiService from './o2Service';
import * as  documentService from "./documentService"
export class ApplicationError extends Error {
    constructor(message: string, applicationId?: string, applicantId?: string, options?: ErrorOptions) {
        // Need to pass `options` as the second parameter to install the "cause" property.
        super(message, options);
        this.name = 'ApplicationError';
        this.applicationId = applicationId;
        this.applicantId = applicantId;
    }
    public applicationId?: string;
    public applicantId?: string;
}

type ServiceMethod =
    | `ApplicationApiService.${Capitalize<keyof typeof ApplicationApi>}`
    | `CddService.${Capitalize<keyof typeof CddService>}`
    | `O2Service.${Capitalize<keyof typeof o2ApiService>}`
    | `DocumentService.${Capitalize<keyof typeof documentService>}`;

export class ServiceInvocationError extends ApplicationError {
    method: ServiceMethod;
    response: unknown;
    status: number;
    config?: RequestInit;
    constructor(
        status: number,
        message: string,
        applicationId: string | undefined,
        applicantId: string | undefined,
        method: ServiceMethod,
        response: unknown,
        config?: RequestInit
    ) {
        super(message, applicationId, applicantId);
        this.status = status;
        this.config = config;
        this.name = 'ServiceInvocationError';
        this.method = method;
        this.response = response;
    }
}

export class ValidationProblemDetailsError extends Error {
    errors: Record<string, string[]>;
    config?: RequestInit;
    constructor(problem: ValidationProblemDetails, config?: RequestInit) {
        super(problem.title);
        this.config = config;
        this.name = 'ValidationProblemDetailsError';
        this.errors = problem.errors;
    }
}
export class ProblemDetailsError extends Error {
    config?: RequestInit;
    constructor(problem: ProblemDetails, config?: RequestInit) {
        super(problem.title);
        this.config = config;
        this.name = 'ProblemDetailsError';
    }
}

type PollType = 'UploadSucess' | 'ExpectedSignState' | 'ExpectedApplicationState';
export class DurationExeededError extends ApplicationError {
    type: PollType | undefined;
    constructor(message: string, applicationId: string, applicantId: string, pollType?: PollType) {
        super(message, applicationId, applicantId);
        this.type = pollType;
    }
}

export async function throwIfNotSuccess(response: Response, method: ServiceMethod, requestInit?: RequestInit) {
    if (response.status == 400) {
        const ct = response.headers.get('content-type');
        if (ct && ct.indexOf('application/problem+json') > -1) {
            const json = await response.json();
            if (isProblemDetails(json)) {
                if (isValidationProblemDetails(json)) {
                    throw new ValidationProblemDetailsError(json, requestInit);
                }
                throw new ProblemDetailsError(json, requestInit);
            }
        }
    }
    if (!response.ok) {
        throw new ServiceInvocationError(
            response.status,
            `Error response ${response.status}  ${response.statusText}`,
            undefined,
            undefined,
            method,
            await response.text(),
            requestInit
        );
    }
}

type ProblemDetails = { title: string; status: number; type: string };
type ValidationProblemDetails = ProblemDetails & { errors: Record<string, string[]> };

function isProblemDetails(problem: unknown): problem is ProblemDetails {
    if (typeof problem == 'object' && problem !== null) {
        return Object.prototype.hasOwnProperty.call(problem, 'title') && Object.prototype.hasOwnProperty.call(problem, 'status');
    }
    return false;
}
function isValidationProblemDetails(problem: ProblemDetails): problem is ValidationProblemDetails {
    return Object.prototype.hasOwnProperty.call(problem, 'errors');
}
export function isConflictServiceInvokationError(error: unknown) {
    return error instanceof ServiceInvocationError && error.status == 409;
}
